import React, { ReactElement, useEffect, useState } from "react";
import { auth } from "../context/firebase";

import styled from "styled-components";

import { Link } from "react-router-dom";
import GetAccessInfo from "./GetAccessInfo";

interface Props {
  setUser: any;
}

export default function LoginForm({ setUser }: Props): ReactElement {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const handleResize = (e: any) => {
      e.keyCode === 13 && handleSubmit();
    };

    window.addEventListener("keypress", handleResize);
    return () => window.removeEventListener("keypress", handleResize);
  });

  const handleSubmit = async () => {
    auth
      .signInWithEmailAndPassword(email, password)
      .then((user: any) => setUser(user))
      .catch((err) => {
        setError(err.message);
        console.log(err);
      });
  };
  return (
    <Container>
      <div className="center login-header">
        <b>LOGIN</b>
      </div>
      <div style={{ padding: "30px 5vw" }}>
        <div>
          <b>Email</b>
        </div>
        <div>
          <input
            type="text"
            style={{ width: "100%", height: "50px" }}
            value={email}
            onChange={(e: any) => {
              setEmail(e.target.value);
            }}
          />
        </div>
        <div>
          <b>Password</b>
        </div>
        <div>
          <input
            type="password"
            value={password}
            onChange={(e: any) => {
              setPassword(e.target.value);
            }}
            style={{ width: "100%", height: "50px" }}
          />
        </div>
        <div style={{ color: "red", marginTop: "10px", marginBottom: "-10px" }}>
          {error}
        </div>
        <div onClick={handleSubmit} className="center button" style={{}}>
          <b>LOGIN</b>
        </div>
        <div style={{ textAlign: "right", cursor: "pointer" }}>
          <Link to="/password">Forgot Password?</Link>
        </div>
        <GetAccessInfo />
        <div className="center" style={{ fontSize: "20px" }}>
          <p>
            Contact us at{" "}
            <a href="mailto:info@bond-iq.de?Subject=Apc-analyzer">
              <b>info@bond-iq.de</b>
            </a>
          </p>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  flex: 0.5;
  background-color: #f9ba00;
  min-height: 100vh;
  padding-top: 50px;

  .login-header {
    font-size: 50px;
  }

  .button {
    background-color: #222222;
    color: white;
    margin-top: 25px;
    height: 50px;
    align-items: center;
    font-size: 30px;
  }

  .button:hover {
    cursor: pointer;
    background-color: #8b8b8b;
  }

  .button:active {
    transform: scale(1.1);
  }

  .center {
    display: flex;
    justify-content: center;
  }
`;
